import { twMerge } from 'tailwind-merge';

interface MediaHeadingProps {
  title: string;
  icon?: React.ReactNode;
  containerClassName?: string;
  defaultIconClassName?: string;
}

export const MediaHeading = ({
  title,
  icon,
  containerClassName,
  defaultIconClassName,
}: MediaHeadingProps) => {
  return (
    <div
      className={twMerge(
        'flex justify-center gap-1.5 bg-purple-EDECFB/80 p-2 pt-1.5 pb-[5px]',
        containerClassName
      )}
    >
      {icon || (
        <i
          className={twMerge(
            '-mt-[4.5px] ki-outline ki-graph-3 text-primary font-bold text-lg shadow-sm',
            defaultIconClassName
          )}
        />
      )}
      <div className="text-sm text-primary font-medium">{title}</div>
    </div>
  );
};
